/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState, useEffect } from 'react';
import { AppDocument } from 'api';
import Popover from '@mui/material/Popover';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import DropdownItem from 'views/Dashboards-B2B/components/DropdownItem';
import * as S from '../../../../../../../../Dashboard.styled';

type SelectDocumentTagDropdownProps = {
    documents: AppDocument[];
    selectedDocument: string;
    handleSelectedDocument: (selectedCase: string) => void;
    mobile: boolean;
    createTicketPopover?: boolean;
};

const SelectDocumentTagDropdown = ({
    documents,
    selectedDocument,
    handleSelectedDocument,
    mobile,
    createTicketPopover,
}: SelectDocumentTagDropdownProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOptionClick = (e: React.MouseEvent<HTMLElement>, document: AppDocument) => {
        e.stopPropagation();
        handleSelectedDocument(document.document_name);
        handleClose();
    };

    useEffect(() => {
        if (createTicketPopover) {
            handleSelectedDocument(t('selectDocument', { lng: language }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <S.LeftDropdown
                mobile={mobile}
                isActive={!!anchorEl}
                style={{ minWidth: '12rem', maxWidth: '12rem' }}
                onClick={(event) => {
                    handleClick(event);
                }}
            >
                <S.SelectionContainer>{selectedDocument}</S.SelectionContainer>

                <S.DropdownIcon />
            </S.LeftDropdown>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    {documents.length ? (
                        documents.map((option: any, i: number) => (
                            <DropdownItem
                                style={{ display: 'inline-block' }}
                                key={i}
                                onClick={(e) => handleOptionClick(e, option)}
                            >
                                {option.document_name}
                            </DropdownItem>
                        ))
                    ) : (
                        <DropdownItem style={{ display: 'inline-block' }}>
                            {t('noDocumentsAvailable', { lng: language })}
                        </DropdownItem>
                    )}
                </S.DropDownMenu>
            </Popover>
        </>
    );
};

export default SelectDocumentTagDropdown;
